import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { tokens } from "../styles";

const NAV_TOP = 56;          // space above the nav on load
const NAV_TOP_SCROLLED = 18; // once scrolled

const Bar = styled.nav`
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(248, 242, 233, 0.86);
  backdrop-filter: saturate(140%) blur(8px);
  -webkit-backdrop-filter: saturate(140%) blur(8px);
`;
const Inner = styled.div`
  max-width: ${tokens.column}px;
  margin: 0 auto;
  padding: ${(p) => (p.$scrolled ? NAV_TOP_SCROLLED : NAV_TOP)}px 24px 14px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  transition: padding 0.35s ease;
`;
const Brand = styled(Link)`
  text-decoration: none;
  font-family: ${tokens.serif};
  font-size: 19px;
  font-weight: 500;
  letter-spacing: -0.01em;
  color: ${tokens.ink};
  white-space: nowrap;
  display: inline-flex;
  align-items: baseline;
  &:hover { color: ${tokens.ink}; }
  .ex {
    display: inline-block;
    overflow: hidden;
    white-space: pre;
    max-width: ${(p) => (p.$collapsed ? 0 : "7ch")};
    opacity: ${(p) => (p.$collapsed ? 0 : 1)};
    transition: max-width 0.55s cubic-bezier(0.2, 0.75, 0.2, 1), opacity 0.4s ease;
  }
  &:hover .ex { max-width: 7ch; opacity: 1; }
  @media (prefers-reduced-motion: reduce) { .ex { transition: none; } }
`;
const Links = styled.div`
  display: flex;
  gap: 20px;
  font-size: 14px;
`;
const NavLink = styled(Link)`
  text-decoration: none;
  color: ${(p) => (p.$active ? tokens.ink : tokens.soft)};
  &:hover { color: ${tokens.blue}; }
`;

export default function Navbar() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Bar $scrolled={scrolled}>
      <Inner $scrolled={scrolled}>
        <Brand to="/" $collapsed={scrolled} aria-label="Jarett Dewbury, home">
          J<span className="ex">arett </span>D<span className="ex">ewbury</span>
        </Brand>
        <Links>
          <NavLink to="/research" $active={pathname.startsWith("/research")}>research</NavLink>
          <NavLink to="/writing" $active={pathname.startsWith("/writing")}>writing</NavLink>
          <NavLink to="/photos" $active={pathname.startsWith("/photos")}>photos</NavLink>
        </Links>
      </Inner>
    </Bar>
  );
}